import { Box, Dialog, Grid, IconButton, Typography } from '@mui/material';
import { MFSubmitButton, MFTextField } from '../../../../lib/formik';
import { Formik, useFormikContext } from 'formik';
import { useDispatch, useSelector } from 'react-redux';
import {
  Distributor,
  getDistributors,
  getDistributorsResponse,
  getRMsList,
  SubDistributor,
} from '../../../../redux-store/actions';
import React, { useEffect, useState } from 'react';
import { RootStateType } from '../../../../redux-store/reducers';
import { useHistory, useLocation } from 'react-router';
import {
  AMC_APPROVER_CHECK_FOR_INDIVIDUAL,
  APPLICATION_TYPE,
  DistributorTypesForUserManageMent,
  USER_ROLES,
} from '../../../../utils/constant';
import UseRadioGroup from '../../../../lib/formik/Radio';
import { distributorsValidationSchema } from '../../../../utils/schema';
import InfoOutlinedIcon from '@mui/icons-material/InfoOutlined';
import {
  applicationComparison,
  applyRoleBasedStatus,
  getCurrentStep,
  navigateToNextStep,
  statusRoleBased,
} from '../../../../utils/utilityFunctions';
import { SearchableSelect } from '../../../../lib/formik/searchSelectField';
import { InfoDialog, Notes } from '../../../investors/components';
import { MenuItemListLink } from '../../InvestorManagementLayout';
import { RMType } from '../../../../redux-store/types/api-types';
import { updateNctApplication } from '../../../../redux-store/actions/nct';

type DistributorDetailsProps = {
  distributorName: string | null;
  distributorId: number | null;
  loginType: string;
  firstName: string;
  empCode: string;
  email: string;
  subdistributorId: number | null;
  subdistributorName: string | null;
  subdistributorEmail: string | null;
  filledBy: string | null;
  distributorEmail: string | null;
  distributorPhone: string | null;
  distributorAlternatePhoneNumber: string | null;
  subdistributorPhone: string | null;
  subdistributorAlternatePhoneNumber: string | null;
  rmId?: number | null;
};

function GridItem({ children }: { children: React.ReactNode }) {
  return (
    <Grid item xs={12} sm={6}>
      {children}
    </Grid>
  );
}

const RMDetail = ({ rms }: { rms: RMType[] }) => {
  const { role = '' } = useSelector((store: RootStateType) => store.auth);
  const { values, setValues } = useFormikContext<DistributorDetailsProps>();
  return (
    <>
      {[USER_ROLES.AMC_ADMIN].includes(role) ? (
        <GridItem>
          <SearchableSelect
            name="rmId"
            label="RM Name *"
            value={values.rmId}
            items={rms
              .sort((rm1, rm2) =>
                (rm1.name || '').toString().localeCompare((rm2.name || '').toString())
              )
              .map((item) => ({
                key: item.name,
                value: item.id,
              }))}
            onChange={({ target: { value } }) => {
              const rm = rms.find((rm) => rm.id === (value as number));
              setValues({ ...values, rmId: rm?.id, email: rm?.user?.email || '' });
            }}
            disabled={![USER_ROLES.AMC_ADMIN].includes(role)}
            searchFieldPlaceholder="Search Distributor"
          />
        </GridItem>
      ) : (
        <GridItem>
          <MFTextField
            name="firstName"
            label="RM Name"
            placeholder="Enter RM name"
            disabled={true}
          />
        </GridItem>
      )}
      <GridItem>
        <MFTextField
          name="email"
          label="RM Email ID"
          placeholder="Enter RM Email ID"
          disabled={true}
        />
      </GridItem>
      {/* <GridItem>
        <MFTextField
          name="empCode"
          label="Employee Code"
          placeholder="Enter Employee Code"
          disabled={true}
        />
      </GridItem> */}
    </>
  );
};

const DistributorDetail = ({
  distributors,
  values,
  selectedDistributor,
  setSelectedDistributor,
}: {
  distributors: Distributor[];
  values: DistributorDetailsProps;
  selectedDistributor: SubDistributor[];
  setSelectedDistributor: (distributor: SubDistributor[]) => void;
}): JSX.Element => {
  const { role } = useSelector((store: RootStateType) => store.auth);
  const { setValues } = useFormikContext();
  const [open, setOpen] = useState(false);

  const handleOpen = () => {
    setOpen(true);
  };
  const handleClose = () => {
    setOpen(false);
  };

  return (
    <>
      {distributors.length > 0 ? (
        <>
          <GridItem>
            <SearchableSelect
              name="distributorId"
              label="Distributor Name *"
              items={distributors
                .sort((distributor1, distributor2) =>
                  (distributor1['name'] || '')
                    .toString()
                    .localeCompare((distributor2['name'] || '').toString())
                )
                .map((item) => ({
                  key: item.name,
                  value: item.id,
                }))}
              onChange={({ target: { value } }) => {
                const distributorCode = distributors.find((item) => item.id === value);
                const {
                  id = null,
                  name,
                  user,
                  alternativeMobileNumber = '',
                } = distributorCode || {};
                const { email, phone } = user || { email: '', phone: '' };
                setValues({
                  ...values,
                  distributorName: name,
                  distributorId: id,
                  subdistributorId: null,
                  subdistributorName: '',
                  subdistributorEmail: '',
                  distributorEmail: email,
                  distributorPhone: phone,
                  distributorAlternatePhoneNumber: alternativeMobileNumber || '',
                  subdistributorPhone: '',
                  subdistributorAlternatePhoneNumber: '',
                });
                setSelectedDistributor(
                  distributors.find((distributor) => distributor.id === value)?.subdistributors ||
                    []
                );
              }}
              disabled={[
                USER_ROLES.DISTRIBUTOR,
                USER_ROLES.INVESTOR,
                USER_ROLES.POAAPPROVER,
                USER_ROLES.SUBDISTRIBUTOR,
              ].includes(role)}
              searchFieldPlaceholder={'Search Distributor'}
            />
          </GridItem>
          {/* <GridItem>
            <MFTextField
              name="distributorName"
              label="Distributor Name *"
              placeholder="Enter Distributor name"
              disabled={true}
            />
          </GridItem> */}
          {values.distributorEmail && values.distributorPhone && (
            <>
              <GridItem>
                <MFTextField
                  name="distributorEmail"
                  label="Distributor Email"
                  placeholder="Enter Distributor Email"
                  disabled={true}
                />
              </GridItem>
              <GridItem>
                <MFTextField
                  name="distributorPhone"
                  label="Distributor Mobile Number"
                  placeholder="Enter Distributor Mobile Number"
                  disabled={true}
                />
              </GridItem>
              <GridItem>
                <MFTextField
                  name="distributorAlternatePhoneNumber"
                  label="Distributor Alternate Mobile Number"
                  placeholder="Enter Distributor Alternate Mobile Numberl"
                  disabled={true}
                />
              </GridItem>
            </>
          )}
          {!!selectedDistributor?.length && (
            <>
              <GridItem>
                <SearchableSelect
                  name="subdistributorId"
                  label="Distributor's RM Name *"
                  items={selectedDistributor
                    .sort((subDistributor1, subDistributor2) =>
                      (subDistributor1.user['firstName'] || '')
                        .toString()
                        .localeCompare((subDistributor2.user['firstName'] || '').toString())
                    )
                    .map((item) => ({
                      key: item.user.firstName || 'N/A',
                      value: item.id,
                    }))}
                  onChange={({ target: { value } }) => {
                    const distributorCode = selectedDistributor.find((item) => item.id === value);
                    const { id = null, user, alternativeMobileNumber = '' } = distributorCode || {};
                    const { email, phone } = user || {};
                    setValues({
                      ...values,
                      subdistributorId: id,
                      subdistributorEmail: email || '',
                      subdistributorPhone: phone || '',
                      subdistributorAlternatePhoneNumber: alternativeMobileNumber || '',
                    });
                  }}
                  disabled={[
                    USER_ROLES.DISTRIBUTOR,
                    USER_ROLES.INVESTOR,
                    USER_ROLES.POAAPPROVER,
                    USER_ROLES.SUBDISTRIBUTOR,
                  ].includes(role)}
                  searchFieldPlaceholder={"Search Distributor's RM"}
                />
              </GridItem>
              {/* <GridItem>
            <MFTextField
              name="subdistributorName"
              label="Distributor's RM Name *"
              placeholder="Enter Distributor name"
              disabled={true}
            />
          </GridItem> */}
              <GridItem>
                <MFTextField
                  name="subdistributorEmail"
                  label="Distributor's RM Email *"
                  placeholder="Enter Distributor email"
                  disabled={true}
                />
              </GridItem>
              <GridItem>
                <MFTextField
                  name="subdistributorPhone"
                  label="Distributor's RM Mobile Number"
                  placeholder="Enter Distributor's RM Mobile Number"
                  disabled={true}
                />
              </GridItem>
              <GridItem>
                <MFTextField
                  name="subdistributorAlternatePhoneNumber"
                  label="Distributor's RM Alternate Mobile Number"
                  placeholder="Enter Distributor's RM Alternate Mobile Numberl"
                  disabled={true}
                />
              </GridItem>
            </>
          )}
          <GridItem>
            <MFTextField name="filledBy" label="Filled by" placeholder="Enter filled by" />
            <Typography
              component="span"
              sx={{ position: 'relative', left: 64, bottom: { xs: 85, md: 91 } }}>
              <InfoOutlinedIcon color="info" fontSize="small" onClick={handleOpen} />
            </Typography>
          </GridItem>
          <InfoDialog
            onClose={handleClose}
            open={open}
            content={'Please specify the name of the representative filling up the form.'}
          />
        </>
      ) : (
        <Grid
          xs={12}
          sm={12}
          sx={{
            fontSize: 18,
            fontWeight: 500,
            color: 'rgb(97, 209, 214)',
            display: 'flex',
            alignItems: 'center',
            textAlign: 'center',
            justifyContent: 'center',
            mt: { lg: 9, xs: 9 },
            mb: 2.9,
            ml: { xs: 3 },
          }}>
          No distributor mapped under this RM
        </Grid>
      )}
    </>
  );
};

export default function DistributorDetailsNCT(): JSX.Element {
  const dispatch = useDispatch();
  const history = useHistory();
  const [distributors, setDistributors] = useState<Distributor[]>([]);
  const { application } = useSelector((store: RootStateType) => store.nctApplication);
  console.log(application);
  const { role } = useSelector((store: RootStateType) => store.auth);
  const [rms, setRms] = useState<RMType[]>([]);
  const [selectedDistributor, setSelectedDistributor] = useState<SubDistributor[]>([]);
  const {
    distributor,
    rm,
    subdistributorId = null,
    subDistributor,
    filledBy = '',
  } = application || {};

  const location = useLocation();
  const path = location.pathname;

  const {
    name,
    id,
    user: { email: distributorEmail, phone: distributorPhone },
    alternativeMobileNumber: distributorAlternatePhoneNumber,
  } = distributor || {
    arnCode: '',
    name: '',
    id: null,
    user: { email: '', phone: '' },
    alternativeMobileNumber: '',
  };

  const {
    id: rmId,
    empCode,
    user: { email: RMEmail = '', firstName: RMFirstName = '' },
  } = rm || { empCode: '', user: { email: '' }, id: '' };

  const {
    user: { firstName: subdistributorName, email: subdistributorEmail, phone: subdistributorPhone },
    alternativeMobileNumber: subdistributorAlternatePhoneNumber,
  } = subDistributor || {
    user: { firstName: '', email: '', phone: '' },
    alternativeMobileNumber: '',
  };

  const initialValues: DistributorDetailsProps = {
    distributorId: id,
    distributorName: name,
    loginType: 'rm',
    empCode,
    email: RMEmail,
    firstName: RMFirstName,
    subdistributorId: subdistributorId === null ? subdistributorId : Number(subdistributorId),
    subdistributorName,
    subdistributorEmail,
    filledBy,
    distributorEmail,
    distributorPhone,
    distributorAlternatePhoneNumber,
    subdistributorPhone,
    subdistributorAlternatePhoneNumber,
    rmId: Number(rmId),
  };

  useEffect(() => {
    (async function () {
      try {
        if (Object.keys(application || {}).length && [USER_ROLES.AMC_ADMIN].includes(role)) {
          const rms = (await dispatch(getRMsList())) as unknown as RMType[];
          setRms(rms);
        }
      } catch (e: unknown) {
        console.error((e as Error).message);
      }
    })();
  }, [application, role]);

  useEffect(() => {
    let isComponentActive = true;
    (async function () {
      try {
        if (Object.keys(application || {}).length && [USER_ROLES.RM].includes(role)) {
          // const rms = (await dispatch(getRMsList())) as unknown as RMType[];
          // console.log(rms);
          const res = (await dispatch(
            getDistributors({ isActive: true })
          )) as unknown as getDistributorsResponse;
          const { distributors = [] } = res || {};
          const updatedDistributor =
            application?.distributor_id && !application.distributor.isActive
              ? [
                  ...distributors,
                  {
                    ...application.distributor,
                    subdistributors: [application.subDistributor],
                  } as Distributor,
                ]
              : distributors;
          if (isComponentActive) {
            const updateSubdistributor =
              application?.distributor_id &&
              application?.distributor.isActive &&
              application?.subdistributorId &&
              !application.subDistributor?.isActive
                ? [
                    ...(updatedDistributor.find((distributor) => distributor.id === id)
                      ?.subdistributors || []),
                    { ...application.subDistributor },
                  ]
                : updatedDistributor.find((distributor) => distributor.id === id)
                    ?.subdistributors || [];
            setSelectedDistributor(updateSubdistributor as unknown as SubDistributor[]);
            setDistributors(updatedDistributor as unknown as Distributor[]);
          }
        } else {
          const { distributor, subDistributor } = application || {};
          setDistributors(distributor ? [distributor as Distributor] : []);
          setSelectedDistributor(
            subDistributor
              ? [{ ...subDistributor, id: Number(subDistributor.id) } as SubDistributor]
              : []
          );
        }
      } catch (e: unknown) {
        console.error((e as Error).message);
      }
    })();
    return () => {
      isComponentActive = false;
    };
  }, [application]);

  const onSubmit = async (values: DistributorDetailsProps) => {
    try {
      const { distributorId, subdistributorId, filledBy, rmId } = values;
      const {
        id,
        applicant1ReferenceId,
        currentStep = null,
        status,
        hasPOA,
        applicationType = '',
      } = application || {};
      const checkApplication = applicationComparison(application, {
        // eslint-disable-next-line @typescript-eslint/no-non-null-assertion
        ...application!,
        distributor_id: distributorId,
        subdistributorId: subdistributorId ? subdistributorId.toString() : subdistributorId,
        filledBy: filledBy,
        currentStep:
          currentStep === null
            ? getCurrentStep(application?.applicationType || '', path)
            : currentStep,
        rm_id: rmId,
      });
      if (id && !checkApplication) {
        await dispatch(
          updateNctApplication({
            body: {
              // eslint-disable-next-line @typescript-eslint/no-non-null-assertion
              ...application!,
              distributor_id: distributorId,
              subdistributorId,
              status: statusRoleBased(role, application),
              currentStep: getCurrentStep(application?.applicationType || '', path),
              // currentStep: applicationType === APPLICATION_TYPE.NON_INDIVIDUAL ? 5 : 6,
              //currentStep === null ? 1 : currentStep
              filledBy,
            },
            applicationId: id,
          })
        );
        history.push(
          navigateToNextStep(
            path,
            role,
            id || '',
            false,
            applicant1ReferenceId || '',
            application?.applicationType || ''
          ),
          {
            id,
            applicant1ReferenceId,
          }
        );
      } else if (checkApplication) {
        history.push(
          navigateToNextStep(
            path,
            role,
            id || '',
            false,
            applicant1ReferenceId || '',
            application?.applicationType || ''
          ),
          {
            id,
            applicant1ReferenceId,
          }
        );
      }
    } catch (e) {
      console.error((e as Error).message);
    }
  };

  return (
    <Formik
      initialValues={initialValues}
      validationSchema={distributorsValidationSchema(selectedDistributor, distributors)}
      onSubmit={onSubmit}
      enableReinitialize={true}>
      {({ handleSubmit, values }) => (
        <Box component="form" noValidate onSubmit={handleSubmit}>
          <Notes
            displayContent={
              'This section specifies the details of the Distributor and RM, as applicable.'
            }
          />
          <Grid container rowSpacing={2} columnSpacing={5}>
            {[USER_ROLES.RM, USER_ROLES.AMC_ADMIN].includes(role) && (
              <Grid item xs={12}>
                <UseRadioGroup
                  formLabel=""
                  name={`loginType`}
                  items={[
                    { label: 'RM', value: USER_ROLES.RM },
                    { label: 'Distributor', value: USER_ROLES.DISTRIBUTOR },
                  ]}
                />
              </Grid>
            )}
            {![USER_ROLES.DISTRIBUTOR, USER_ROLES.SUBDISTRIBUTOR, USER_ROLES.POAAPPROVER].includes(
              role
            ) && values.loginType === USER_ROLES.RM ? (
              <RMDetail rms={rms} />
            ) : (
              <DistributorDetail
                distributors={distributors}
                values={values}
                selectedDistributor={selectedDistributor}
                setSelectedDistributor={(subdistributors) =>
                  setSelectedDistributor(subdistributors)
                }
              />
            )}
          </Grid>
          <Box sx={{ width: '100%', maxWidth: '350px', mx: 'auto', mt: 5 }}>
            <MFSubmitButton label="Next" />
          </Box>
        </Box>
      )}
    </Formik>
  );
}
